export default "__VITE_ASSET__CCnoqbPX__"